import React from "react";
import { AvatarProps } from "@sonder/ui/source/styled/components/Avatar";
import {
  MultiAvatar as MultiAvatarFragment,
  SingularAvatar,
  TotalAvatar,
} from "@sonder/ui/source/styled/fragments/MultiAvatar";

interface MultiAvatarProps {
  avatars?: AvatarProps[];
  className?: string;
  maxLength?: number;
  onClick?(e: React.MouseEvent): void;
}

export const MultiAvatar = ({
  avatars = [],
  className,
  maxLength = 1,
  onClick,
}: MultiAvatarProps) => {
  const [slicedAvatars, remainingAvatars] = [
    avatars.slice(0, maxLength),
    avatars.slice(maxLength, avatars.length + 1),
  ];
  const remainingNames = remainingAvatars.map(avatar => avatar.name).join(", ");
  const totalAvatars = remainingAvatars.length > 0 && (
    <TotalAvatar className={className} title={`And: ${remainingNames}`}>
      {`+${remainingAvatars.length}`}
    </TotalAvatar>
  );
  const fallbackAvatar = avatars.length === 0 ? <SingularAvatar /> : null;
  return (
    <MultiAvatarFragment className={className} onClick={onClick}>
      {totalAvatars}
      {fallbackAvatar}
      {slicedAvatars.reverse().map(avatar => (
        <SingularAvatar key={`${avatar.name}:${avatar.imageUrl}`} {...avatar} />
      ))}
    </MultiAvatarFragment>
  );
};
